import * as React from 'react';
import { connect } from 'react-redux';
import './BuildingDetails.css';
import { setStep, setQuoteData } from '../../../../actions/salesActions';
import { ISelectableTile } from '../../../../interfaces/KPSelectableTile/KPSelectableTileInterfaces';
import KPSelectableTileContainer from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableTile/KPSelectableTileContainer';

class BuildingDetails extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            items: this.getListDataSet(),
            buildingAdditional: this.props.sales.buildingAdditional ?? { thatchRoof: false, thatchLapa: false, alternativePower: false, woodenWalls: false },
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNoneSelected = this.handleNoneSelected.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
    }

    componentDidMount() {
        this.checkSubmit();
    }

    checkSubmit() {
        this.setState({ nextDisabled: !(this.state.buildingAdditional?.thatchLapa || this.state.buildingAdditional?.thatchRoof || this.state.buildingAdditional?.woodenWalls || this.state.buildingAdditional?.alternativePower) });
    }

    handleNoneSelected() {
        this.props.dispatchAction(
            setQuoteData({
                buildingAdditional: { thatchRoof: false, thatchLapa: false, alternativePower: false, woodenWalls: false },
                buildingAdditionalDetail: { thatch_lightningConductor: false, thatch_fireExtinguisher: false, thatch_fireRetardantTreatment: false, thatch_harveyTiles: false, thatch_distanceBetween: null, alternativePower_replacementValue: null },
            })
        );
        this.props.dispatchAction(setStep(10, 1));
    }

    handleItemSelect(id: string, selected: boolean) {
        let name = id.slice(3);
        name = name.charAt(0).toLowerCase() + name.slice(1);
        this.setState({ buildingAdditional: { ...this.state.buildingAdditional, [name]: selected } }, () => this.checkSubmit());
    }

    handleNextStep() {
        if (!this.state.nextDisabled) {
            let buildingAdditionalDetail = { ...this.props.sales.buildingAdditionalDetail };
            if (!this.state.buildingAdditional.thatchRoof) {
                buildingAdditionalDetail.thatch_lightningConductor = false;
                buildingAdditionalDetail.thatch_fireExtinguisher = false;
                buildingAdditionalDetail.thatch_fireRetardantTreatment = false;
                buildingAdditionalDetail.thatch_harveyTiles = false;
            }
            if (!this.state.buildingAdditional.thatchLapa) {
                buildingAdditionalDetail.thatch_distanceBetween = null;
            }
            if (!this.state.buildingAdditional.alternativePower) {
                buildingAdditionalDetail.alternativePower_replacementValue = null;
            }

            this.props.dispatchAction(
                setQuoteData({
                    buildingAdditional: this.state.buildingAdditional,
                    buildingAdditionalDetail
                })
            );

            if (this.state.buildingAdditional.alternativePower) {
                this.props.dispatchAction(setStep(9, 2));
            }
            else if (this.state.buildingAdditional.thatchRoof || this.state.buildingAdditional.thatchLapa) {
                this.props.dispatchAction(setStep(9, 3));
            }
            else {
                this.props.dispatchAction(setStep(10, 1));
            }
        }
    }

    getListDataSet(): ISelectableTile[] {
        let dataSet: ISelectableTile[] = [];

        dataSet.push({
            id: "chkThatchRoof",
            value: "ThatchRoof",
            tileImage: "./Images/BuildingAndHomeContent/thatch-roof.svg",
            title: "Thatch Roof",
            body: "By this we mean any roof that’s woven together by natural materials, such as straw, reed, or palm leaves.",
            selected: (this.props.sales.buildingAdditional?.thatchRoof ?? false),
            handleSelect: null,
            className: "",
            colClassName:"col-md-3"
        } as ISelectableTile);

        dataSet.push({
            id: "chkThatchLapa",
            value: "ThatchLapa",
            tileImage: "./Images/BuildingAndHomeContent/thatch-lapa.svg",
            title: "A thatch Lapa",
            body: "A type of outdoor structure made with a thatch roof and an open-air design. (Hint: Many braai masters love this spot!)",
            selected: (this.props.sales.buildingAdditional?.thatchLapa ?? false),
            handleSelect: null,
            className: "",
            colClassName:"col-md-3"
        } as ISelectableTile);

        dataSet.push({
            id: "chkWoodenWalls",
            value: "WoodenWalls",
            tileImage: "./Images/BuildingAndHomeContent/wooden-walls.svg",
            title: "Wooden Walls",
            body: "By wooden walls we mean any walls made of wooden panels, planks or boards. Nice and simple, hey?",
            selected: (this.props.sales.buildingAdditional?.woodenWalls ?? false),
            handleSelect: null,
            className: "",
            colClassName:"col-md-3"
        } as ISelectableTile);

        dataSet.push({
            id: "chkAlternativePower",
            value: "AltPower",
            tileImage: "./Images/BuildingAndHomeContent/alternative-power.svg",
            title: "Alternative Power",
            body: "By ‘alternative power’ we mean any system that provides electrical energy from solar panels, an inverter, generator, or a battery storage system.",
            selected: (this.props.sales.buildingAdditional?.alternativePower ?? false),
            handleSelect: null,
            className: "",
            colClassName:"col-md-3"
        } as ISelectableTile);

        return dataSet;
    }

    public render() {
        return (
            <div className="text-center container">
                Does the building have any of the following?

                <div className="mt-4">
                    <KPSelectableTileContainer
                        radioGroup={false}
                        items={this.state.items}
                        handleSelect={this.handleItemSelect}
                    />
                </div>

                <div className="row">
                    <div className="col-md-6 text-right mt-4">
                        <button type="button" className="btn btn-outline-red btnNavigate" onClick={this.handleNoneSelected}>None of the above</button>
                    </div>

                    <div className="col-md-6 text-left mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingDetails);